import React from 'react';

import { deprecate } from 'react-is-deprecated';

import PropTypes from 'prop-types';

import querystring from 'querystring';

/**
 *  Price Advisor renders iframe to display KBB fair market range
 *
 */
function PriceAdvisor({
    listing, // DEPRECATED
    advisorType = 'fairpurchaseprice',
    apiUrl,
    className = 'margin-horizontal-auto display-block',
    clientId,
    displayFPP = false,
    height = '375',
    listingType,
    optionIds,
    showAskingPrice = false,
    vehicleId,
    vin,
    width = '300',
    zip = '',
    ...rest
}) {

    let privateSeller = advisorType === 'privateparty';

    // backward-compatible support for deprecated props
    let deprecatedMode = false;
    if (!listingType) listingType = listing?.type;
    if (!vin) vin = listing?.vin;
    if (listing?.owner?.privateSeller) {
        privateSeller = true;
        deprecatedMode = true;
    }
    if (!clientId) clientId = listing?.priceAdvisor?.clientId;
    if (!apiUrl) {
        apiUrl = listing?.priceAdvisor?.apiUrl;
        deprecatedMode = true;
    }

    // Don't render if we are missing required info
    if (!apiUrl || !clientId) {
        return null;
    }

    const newCar = listingType.toLowerCase() === 'new';
    const displayPrice = newCar ? 'displaymsrp' : 'displaysrp';
    const vehicleConditionParam = newCar ? 'newcar' : 'usedcar';

    let params = {
        clientid: clientId,
        vin,
        zipcode: zip,
        backgroundcolor: 'transparent',
        vehicleId,
        optionIds,
    };

    if (!privateSeller) {
        params = {
            ...params,
            displayfpp: displayFPP,
            displayaskingprice: showAskingPrice,
            [displayPrice]: newCar,
        };
    }

    const urlParams = querystring.stringify(params);
    let source = `${apiUrl}/priceadvisor${vehicleConditionParam}/${advisorType}?${urlParams}`;

    if (privateSeller) {
        source = `${apiUrl}/${vehicleConditionParam}/${advisorType}/buy?${urlParams}`;
    }

    if (deprecatedMode) {
        // Expects apiUrl to have constructed path
        source = `${apiUrl}${privateSeller ? '' : `/${advisorType}`}?${urlParams}`;
    }

    return (
        <iframe
            className={className}
            data-cmp="priceAdvisor"
            loading="lazy"
            title={'KBB.com Price Advisor information for ' + vin}
            width={width}
            height={height}
            style={{ border: 'none' }}
            src={source}
            {...rest}
        />
    );
}

PriceAdvisor.propTypes /* remove-proptypes */ = {
    type: PropTypes.string,
    vin: PropTypes.string,

    apiUrl: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired,

    advisorType: PropTypes.oneOf(['fairpurchaseprice', 'tradein', 'privateparty']),

    className: PropTypes.string,
    showAskingPrice: PropTypes.bool,
    displayFPP: PropTypes.bool,

    width: PropTypes.string,
    height: PropTypes.string,

    // For Custom Order that doesn't align to a specific listing
    vehicleId: PropTypes.string,
    optionIds: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

    zip: PropTypes.string,

    listing: deprecate(PropTypes.shape({
        owner: PropTypes.object,
        type: PropTypes.string, // replaced by listingType
        vin: PropTypes.string,
        priceAdvisor: PropTypes.object, // replaced by apiUrl, clientId
    }), 'listing is deprecated. Please pass in the data via individual props'),
    frameBorder: deprecate(PropTypes.string, 'frameBorder is deprecated per HTML standards.'),
    scrolling: deprecate(PropTypes.oneOf(['yes', 'no']), 'scrolling is deprecated per HTML standards.'),

};

export default PriceAdvisor;
